import React from 'react';
import { useTranslation } from 'react-i18next';

const SubFooter = () => {
    const { t } = useTranslation('common');

    return (
        <div className="subfooter">
            <p>{t('productBy', { ns: 'common' })}</p>
            <a href="https://www.eventful.se/" target="_blank"><img src="https://eventfulcdn.blob.core.windows.net/flowsync/eventful_logo.svg" alt="Eventful" /></a>
        </div>
    )
}

export default SubFooter;